class Error {
  constructor() {
    this.name = this.constructor.name;
  }
}

export class PublicError extends Error {
  constructor(title, message, error) {
    super();

    this.title = title;
    this.message = message;
    this.error = error;
  }
}

export class ValidationError extends PublicError {
  constructor(field, message) {
    super(message);

    this.field = field;
  }
}
